// extracted by mini-css-extract-plugin
module.exports = {"container":"_2jmBtKCZuoS0u4r2xz5BcL"};